<div class="input-group flex-nowrap">
  <span class="input-group-text"><i class="bi {{ iconClass }}"></i> </span>
  <input [(ngModel)]="localValue" step="{{ step }}" min="{{ min }}" max="{{ max }}" [disabled]="isDisabled || disabled"
    (ngModelChange)="onValueChange($event)" type="number" class="form-control form-control-lg"
    placeholder="{{ placeholder }}" />
  <span *ngIf="suffixText" class="input-group-text">{{ suffixText }}</span>
</div>
